import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
  namespaced: true,
  state() {
    return {
      request_error: '',
      inventory_of_search: [],
      selected_inventory: {}
    };
  },
  mutations,
  actions,
  getters
};